import gsap from 'gsap';
import Sniffer from 'sniffer';
import TinyGesture from 'tinygesture';
import DrawSVGPlugin from 'gsap/DrawSVGPlugin';

gsap.registerPlugin(DrawSVGPlugin);

export default class Slides {
  constructor() {
    this.body = document.querySelector('body');

    this.mask = document.querySelectorAll('.s-slides-mask');
    this.shape = document.querySelectorAll('.s-slides-shape');
    this.image = document.querySelectorAll('.s-slides-image');

    this.headings = {
      el: document.querySelector('.s-slides-headings'),
      events: document.querySelectorAll('.s-slides-heading-inner'),
      heading: document.querySelectorAll('.s-slides-heading'),
      lines: document.querySelectorAll('.s-slides-heading .f-xl-line'),
      paragraphs: document.querySelectorAll('.s-slides-heading p'),
    };

    this.nav = {
      el: document.querySelector('.s-slides-nav'),
      line: document.querySelector('.s-slides-line'),
      buttons: document.querySelector('.s-slides-buttons'),
      button: document.querySelectorAll('.s-slides-button'),
    };

    this.footer = document.querySelector('.p-home .s-footer');
    this.cursor = document.querySelector('.i-indicator');
    this.loader = document.querySelector('.s-slides-loader');
    this.links = document.querySelectorAll('.s-slides-link');

    this.prev = 3;
    this.next = 1;
    this.current = 0;

    this.page = undefined;
    this.animating = false;
    this.gesture = undefined;

    if (Sniffer.isDevice) {
      this.gesture = new TinyGesture(this.body);
    }
  }

  setSizes = () => {
    this.ww = window.innerWidth;
    this.wh = window.innerHeight;
  }

  setCursor = () => {
    gsap.to(this.cursor, {
      duration: 1.5,
      ease: 'expo.inOut',
      transformOrigin: 'center center',
      drawSVG: `0% ${100 / 4 * (this.current + 1)}%`,
    });
  }

  setNav = () => {
    let i;

    if (this.page === undefined) { i = this.current; } else { i = this.page; }

    gsap.to(this.nav.button, {
      duration: 1,
      opacity: 0.4,
      pointerEvents: '',
    });
    gsap.to(this.nav.button[i], {
      opacity: 1,
      duration: 1,
      pointerEvents: 'none',
    });
    gsap.to(this.nav.line, {
      duration: 1.5,
      ease: 'expo.inOut',
      width: this.nav.button[i].clientWidth,
      x: Math.round(this.nav.button[i].getBoundingClientRect().left - this.nav.buttons.getBoundingClientRect().left),
    });
  }

  setHeadings = () => {
    const active = this.headings.heading[0].querySelectorAll('.f-xl-line');
    const activeParagraph = this.headings.paragraphs[0];

    gsap.set(this.footer, { opacity: 1 });
    gsap.set(this.headings.lines, {
      x: this.ww,
    });
    gsap.set(active, {
      x: 0,
    });
    gsap.set(this.headings.paragraphs, {
      autoAlpha: 0,
    });
    gsap.set(activeParagraph, {
      autoAlpha: 1,
    });
  }

  setImagesOp = () => {
    if (Sniffer.isPhone) return;

    gsap.set(this.image[0], { opacity: 1 });
    gsap.set(this.image[1], { opacity: 0.35 });
    gsap.set(this.image[2], { opacity: 0.35 });
    gsap.set(this.image[3], { opacity: 0.35 });
  }

  setMasks = () => {
    if (Sniffer.isPhone) {
      gsap.set(this.mask[0], {
        x: Math.round(this.ww * 0.168),
        y: -Math.round(this.ww / 2),
        width: Math.round(this.ww * 0.66),
        height: Math.round(this.ww),
      });
      gsap.set(this.mask[1], {
        x: Math.round(this.ww * 0.898),
        y: -Math.round(this.ww * 0.1),
        width: Math.round(this.ww * 0.43),
        height: Math.round(this.ww * 0.6),
      });
      gsap.set(this.mask[2], {
        x: Math.round(this.ww + this.ww * 0.5),
        y: -Math.round(this.ww * 0.1),
        width: Math.round(this.ww * 0.43),
        height: Math.round(this.ww * 0.6),
      });
      gsap.set(this.mask[3], {
        x: -Math.round(this.ww * 0.333),
        y: -Math.round(this.ww * 0.5),
        width: Math.round(this.ww * 0.43),
        height: Math.round(this.ww * 0.6),
      });
    } else {
      gsap.set(this.mask[0], {
        x: Math.round(this.ww * 0.336),
        y: -Math.round(this.ww * 0),
        width: Math.round(this.ww * 0.397),
        height: Math.round(this.ww * 0.312),
      });
      gsap.set(this.mask[1], {
        x: Math.round(this.ww * 0.813),
        y: Math.round(this.ww * 0.085),
        width: Math.round(this.ww * 0.187),
        height: Math.round(this.ww * 0.197),
      });
      gsap.set(this.mask[2], {
        x: Math.round(this.ww + this.ww * 0.203),
        y: Math.round(this.ww * 0.085),
        width: Math.round(this.ww * 0.14),
        height: Math.round(this.ww * 0.197),
      });
      gsap.set(this.mask[3], {
        x: 0,
        y: -Math.round(this.ww * 0.105),
        width: Math.round(this.ww * 0.258),
        height: Math.round(this.ww * 0.245),
      });
    }
  }

  setImages = () => {
    gsap.set(this.shape, {
      yPercent: -100,
    });
    gsap.set(this.image, {
      scale: 1.2,
      opacity: Sniffer.isPhone ? 0.35 : 1,
    });
  }

  setTween = () => {
    this.setNav();
    this.setCursor();
  }

  resetTween = () => {
    this.animating = false;
  }

  prevTween = () => {
    if (this.animating === true) return;
    this.animating = true;

    this.resetEvents();

    gsap.fromTo(this.headings.heading[this.current].querySelectorAll('.f-xl-line'), {
      x: 0,
    }, {
      x: this.ww,
      stagger: 0.05,
      duration: 1.5,
      ease: 'expo.inOut',
    });

    if (this.current === 0) {
      this.next = 0;
      this.prev = 2;
      this.hidden = 1;
      this.current = this.image.length - 1;
    } else {
      this.current = this.current - 1;
      this.next = this.current + 1;
      this.prev = this.current - 1;
      this.hidden = this.next + 1;
    }
    if (this.prev < 0) {
      this.prev = this.image.length - 1;
    }
    if (this.hidden === 4) {
      this.hidden = 0;
    }

    gsap.fromTo(this.headings.heading[this.current].querySelectorAll('.f-xl-line'), {
      x: -Math.round(this.ww),
    }, {
      x: 0,
      duration: 1.5,
      stagger: 0.05,
      autoRound: false,
      ease: 'expo.inOut',
    }, 0);

    const tl = gsap.timeline({
      defaults: {
        duration: 1.5,
        autoRound: false,
        ease: 'expo.inOut',
      },
      onComplete: () => {
        this.resetTween();
      },
    });

    if (Sniffer.isPhone) {
      tl
        .to(this.mask[this.hidden], {
          x: Math.round(this.ww + this.ww * 0.5),
          y: -Math.round(this.ww * 0.1),
          width: Math.round(this.ww * 0.14),
          height: Math.round(this.ww * 0.197),
        }, 0)
        .set(this.mask[this.prev], {
          x: -Math.round(this.ww * 0.43 + this.ww * 0.5),
          y: -Math.round(this.ww * 0.5),
          width: Math.round(this.ww * 0.43),
          height: Math.round(this.ww * 0.6),
        }, 0)
        .to(this.mask[this.prev], {
          x: -Math.round(this.ww * 0.333),
          y: -Math.round(this.ww * 0.5),
          width: Math.round(this.ww * 0.43),
          height: Math.round(this.ww * 0.6),
        }, 0)
        .to(this.mask[this.next], {
          x: Math.round(this.ww * 0.898),
          y: -Math.round(this.ww * 0.1),
          width: Math.round(this.ww * 0.43),
          height: Math.round(this.ww * 0.6),
        }, 0)
        .to(this.mask[this.current], {
          x: Math.round(this.ww * 0.168),
          y: -Math.round(this.ww / 2),
          width: Math.round(this.ww * 0.66),
          height: Math.round(this.ww),
        }, 0);
    } else {
      tl
        .to(this.mask[this.hidden], {
          x: Math.round(this.ww + this.ww * 0.203),
          y: Math.round(this.ww * 0.085),
          width: Math.round(this.ww * 0.14),
          height: Math.round(this.ww * 0.197),
        }, 0)
        .set(this.mask[this.prev], {
          x: -Math.round(this.ww * 0.203),
          y: -Math.round(this.ww * 0.155),
          width: Math.round(this.ww * 0.14),
          height: Math.round(this.ww * 0.187),
        }, 0)
        .to(this.mask[this.prev], {
          x: 0,
          y: -Math.round(this.ww * 0.105),
          width: Math.round(this.ww * 0.258),
          height: Math.round(this.ww * 0.245),
        }, 0)
        .to(this.mask[this.next], {
          x: Math.round(this.ww * 0.813),
          y: Math.round(this.ww * 0.085),
          width: Math.round(this.ww * 0.187),
          height: Math.round(this.ww * 0.197),
        }, 0)
        .to(this.mask[this.current], {
          x: Math.round(this.ww * 0.336),
          y: -Math.round(this.ww * 0),
          width: Math.round(this.ww * 0.397),
          height: Math.round(this.ww * 0.312),
        }, 0);
    }

    tl.to(this.headings.paragraphs[this.next], {
      autoAlpha: 0,
      duration: 0.75,
    }, 0)
      .fromTo(this.headings.paragraphs[this.current], {
        autoAlpha: 0,
        duration: 0.5,
      }, {
        autoAlpha: 1,
        y: 0,
      }, 0.5)
      .to(this.image[this.current], {
        opacity: Sniffer.isPhone ? 0.35 : 1,
      }, 0.5)
      .to(this.image[this.prev], {
        opacity: 0.35,
      }, 0.5)
      .to(this.image[this.next], {
        opacity: 0.35,
      }, 0.5);

    this.setTween();
    this.setEvents();
  }

  nextTween = () => {
    if (this.animating === true) return;
    this.animating = true;

    this.resetEvents();

    gsap.fromTo(this.headings.heading[this.current].querySelectorAll('.f-xl-line'), {
      x: 0,
    }, {
      x: -this.ww,
      stagger: 0.05,
      duration: 1.5,
      ease: 'expo.inOut',
    });

    if (this.current === this.image.length - 1) {
      this.next = 1;
      this.prev = 3;
      this.current = 0;
      this.hidden = 2;
    } else {
      this.current = this.current + 1;
      this.next = this.current + 1;
      this.prev = this.current - 1;
      this.hidden = this.prev - 1;
    }
    if (this.next === 4) {
      this.next = 0;
    }
    if (this.hidden === -1) {
      this.hidden = 3;
    }

    gsap.fromTo(this.headings.heading[this.current].querySelectorAll('.f-xl-line'), {
      x: Math.round(this.ww),
    }, {
      x: 0,
      stagger: 0.05,
      duration: 1.5,
      ease: 'expo.inOut',
    }, 0);

    const tl = gsap.timeline({
      defaults: {
        duration: 1.5,
        autoRound: false,
        ease: 'expo.inOut',
      },
      onComplete: () => {
        this.resetTween();
      },
    });

    if (Sniffer.isPhone) {
      tl
        .to(this.mask[this.hidden], {
          x: -Math.round(this.ww * 0.43 + this.ww * 0.5),
          y: -Math.round(this.ww * 0.5),
          width: Math.round(this.ww * 0.43),
          height: Math.round(this.ww * 0.6),
        }, 0)
        .set(this.mask[this.hidden], {
          x: Math.round(this.ww + this.ww * 0.5),
          y: -Math.round(this.ww * 0.1),
          width: Math.round(this.ww * 0.43),
          height: Math.round(this.ww * 0.6),
        }, 1.5)
        .to(this.mask[this.prev], {
          x: -Math.round(this.ww * 0.333),
          y: -Math.round(this.ww * 0.5),
          width: Math.round(this.ww * 0.43),
          height: Math.round(this.ww * 0.6),
        }, 0)
        .to(this.mask[this.current], {
          x: Math.round(this.ww * 0.168),
          y: -Math.round(this.ww / 2),
          width: Math.round(this.ww * 0.66),
          height: Math.round(this.ww),
        }, 0)
        .to(this.mask[this.next], {
          x: Math.round(this.ww * 0.898),
          y: -Math.round(this.ww * 0.1),
          width: Math.round(this.ww * 0.43),
          height: Math.round(this.ww * 0.6),
        }, 0);
    } else {
      tl
        .to(this.mask[this.hidden], {
          x: -Math.round(this.ww * 0.203),
          y: -Math.round(this.ww * 0.155),
          width: Math.round(this.ww * 0.14),
          height: Math.round(this.ww * 0.187),
        }, 0)
        .set(this.mask[this.hidden], {
          x: Math.round(this.ww + this.ww * 0.203),
          y: Math.round(this.ww * 0.085),
          width: Math.round(this.ww * 0.14),
          height: Math.round(this.ww * 0.197),
        }, 1.5)
        .to(this.mask[this.prev], {
          x: 0,
          y: -Math.round(this.ww * 0.105),
          width: Math.round(this.ww * 0.258),
          height: Math.round(this.ww * 0.245),
        }, 0)
        .to(this.mask[this.current], {
          x: Math.round(this.ww * 0.336),
          y: -Math.round(this.ww * 0),
          width: Math.round(this.ww * 0.397),
          height: Math.round(this.ww * 0.312),
        }, 0)
        .to(this.mask[this.next], {
          x: Math.round(this.ww * 0.813),
          y: Math.round(this.ww * 0.085),
          width: Math.round(this.ww * 0.187),
          height: Math.round(this.ww * 0.197),
        }, 0);
    }
    tl.to(this.headings.paragraphs[this.prev], {
      autoAlpha: 0,
      duration: 0.75,
    }, 0)
      .fromTo(this.headings.paragraphs[this.current], {
        autoAlpha: 0,
        duration: 0.5,
      }, {
        autoAlpha: 1,
        y: 0,
      }, 0.5)
      .to(this.image[this.current], {
        opacity: Sniffer.isPhone ? 0.35 : 1,
      }, 0.5)
      .to(this.image[this.prev], {
        opacity: 0.35,
      }, 0.5)
      .to(this.image[this.next], {
        opacity: 0.35,
      }, 0.5);

    this.setTween();
    this.setEvents();
  }

  getPage = (i) => {
    if (this.animating === true) return;

    this.dummy = document.createElement('img');
    this.dummy.src = this.image[i].src;
    this.dummy.classList.add('s-slides-image');

    this.shape[this.current].appendChild(this.dummy);
    this.page = i;

    this.setTween();

    const tl = gsap.timeline({
      defaults: {
        duration: 1.5,
        ease: 'expo.inOut',
        onComplete: () => {
          this.loadPage();
        },
      },
    });

    tl
      .to(this.shape, {
        yPercent: 0,
      }, 0)

      .set(this.dummy, {
        yPercent: 100,
      }, 0)

      .to(this.dummy, {
        yPercent: 0,
        opacity: Sniffer.isPhone ? 0.35 : 1,
      }, 0);
  }

  loadPage = () => {
    if (this.load || this.animating === true) return;
    if (this.body.classList.contains('is-loading')) return;

    this.load = true;
    this.animating = true;

    if (this.page === undefined) {
      this.links[this.current].click();
    } else {
      this.links[this.page].click();
    }

    const tl = gsap.timeline({
      defaults: {
        duration: 1.5,
        ease: 'expo.inOut',
      },
    });

    tl
      .set(this.mask[this.current], {
        zIndex: 2,
      }, 0)

      .to(this.mask[this.current], {
        x: 0,
        y: -Math.round(this.wh / 2),
        width: Math.round(this.ww),
        height: Math.round(this.wh),
      }, 1)

      .to(this.image, {
        scale: 1,
        opacity: 0,
      }, 1)

      .to(this.image[this.current], {
        opacity: 0.6,
      }, 1)
      .to(this.dummy, {
        opacity: 0.6,
      }, 1)
      .to(this.image[this.prev], {
        opacity: 0.35,
      }, 1)
      .to(this.image[this.next], {
        opacity: 0.35,
      }, 1)

      .to(this.cursor, {
        drawSVG: '0% 0%',
      }, 0)

      .to(this.nav.el, {
        opacity: 0,
        y: -Math.round(this.ww * 0.104),
      }, 1)

      .fromTo(this.headings.heading[this.current].querySelectorAll('.f-xl-line'), {
        y: 0,
      }, {
        y: -Math.round(this.wh),
        stagger: 0.05,
      }, 1)

      .to(this.headings.paragraphs[this.current], {
        autoAlpha: 0,
        duration: 0.75,
      }, 0.8);
  }

  mouseEnter = (i) => {
    gsap.to(this.image[i], {
      scale: 1,
      duration: 0.5,
      force3D: true,
    });
  }

  mouseLeave = () => {
    if (this.load === true) return;
    gsap.to(this.image, {
      scale: 1.2,
      duration: 0.5,
      force3D: true,
    });
  }

  wheelSlide = (e) => {
    if (this.animating === true) return;
    if (e.deltaY < 0) {
      this.prevTween();
    } else if (e.deltaY > 0) {
      this.nextTween();
    }
  }

  resetEvents = () => {
    this.mask[this.current].removeEventListener('click', this.loadPage);
    this.headings.events[this.current].removeEventListener('click', this.loadPage);
    this.headings.events[this.current].style.pointerEvents = 'none';
    this.mask[this.prev].removeEventListener('click', this.prevTween);
    this.mask[this.next].removeEventListener('click', this.nextTween);
  }

  setEvents = () => {
    this.mask[this.current].addEventListener('click', this.loadPage);
    this.headings.events[this.current].addEventListener('click', this.loadPage);
    this.headings.events[this.current].style.pointerEvents = 'auto';
    this.mask[this.prev].addEventListener('click', this.prevTween);
    this.mask[this.next].addEventListener('click', this.nextTween);
  }

  addEvents = () => {
    window.addEventListener('resize', this.set);
    window.addEventListener('wheel', (e) => {
      this.wheelSlide(e);
    });

    [...this.mask].forEach((el, i) => {
      el.addEventListener('mouseenter', () => {
        this.mouseEnter(i);
      });
      el.addEventListener('mouseleave', () => {
        this.mouseLeave();
      });
    });

    [...this.nav.button].forEach((el, i) => {
      el.addEventListener('click', () => {
        this.getPage(i);
      });
    });

    if (Sniffer.isDevice) {
      this.gesture.on('swipeleft', this.nextTween);
      this.gesture.on('swiperight', this.prevTween);
    }

    this.customSlideToHandler = (e) => {
      if (e.detail.direction === 'prev') this.prevTween();
      else this.nextTween();
    };
    window.addEventListener('customSlideTo', this.customSlideToHandler);

    window.addEventListener('keydown', this.arrowEvents);
  }

  removeEvents = () => {
    window.removeEventListener('resize', this.set);
    window.removeEventListener('wheel', (e) => {
      this.wheelSlide(e);
    });

    window.removeEventListener('customSlideTo', this.customSlideToHandler);
    window.removeEventListener('keydown', this.arrowEvents);
  }

  arrowEvents = (e) => {
    switch (e.which) {
      case 37:
        this.prevTween();
        break;

      case 39:
        this.nextTween();
        break;

      default:
        return; // eslint-disable-line
    }
  }

  set = () => {
    this.current = 0;

    this.setNav();
    this.setSizes();
    this.setMasks();
    this.setImages();
    this.setCursor();
    this.setHeadings();
    this.setImagesOp();
  }

  destroy = () => {
    this.removeEvents();
  }

  init = () => {
    this.set();
    this.addEvents();
    this.setEvents();
  }
}
